import { Routes } from '@angular/router';
import { idCheckingGuard } from '../Guards/id-checking-guard';
import { portalAuthGuard } from '../Guards/portal-auth-guard';
import { onboardingLoginGuard } from '../Guards/onboarding-login-guard';
import { PortalLogin } from './PatientLogin/portal-login/portal-login';

export const routes: Routes = [
  //   {
  //   path: 'login',
  //   canActivate: [idCheckingGuard],
  //   loadComponent: () =>
  //     import('./PatientLogin/login/login').then(m => m.Login)
  // },
  {
    path: 'portalLogin',
    children: [
      {
        path: '',
        component: PortalLogin,
        canActivate: [idCheckingGuard]
      },
      {
        path: ':OrgCode/:BranchId',
        component: PortalLogin,
        canActivate: [idCheckingGuard]
      }
    ]
  },
  // {
  //   path: 'patientonboardingLogin',
  //   canActivate: [onboardingLoginGuard],
  //   loadComponent: () =>
  //     import('./PatientLogin/patient-onboarding-login/patient-onboarding-login')
  //       .then(m => m.PatientOnboardingLogin)
  // },
  {
  path: 'QRPatientOngoing/:token',
  canActivate: [onboardingLoginGuard],
  loadComponent: () =>
    import('./PatientLogin/patient-onboarding-login/patient-onboarding-login')
      .then(m => m.PatientOnboardingLogin)
},
  // Book-appointment onboarding email/SMS link (…/#!/POL/<token>) — same flow as QR
  {
  path: 'POL/:token',
  canActivate: [onboardingLoginGuard],
  loadComponent: () =>
    import('./PatientLogin/patient-onboarding-login/patient-onboarding-login')
      .then(m => m.PatientOnboardingLogin)
},
   {
    path: 'patientonboarding/:PatientId/:OrganizationId/:AppointmentId',
    loadComponent: () =>
      import('./PatientOnboarding/patientonboarding/patientonboarding')
        .then(m => m.Patientonboarding)
  },
  /* ---------------- NORMAL APP ---------------- */

  {
    path: '',
    canActivate: [idCheckingGuard],
    children: [
      {
        path: 'patientReferral',
        loadComponent: () =>
          import('./PatientReferral/patient-referral/patient-referral')
            .then(m => m.PatientReferral)
      },
      {
        path: 'patientPayments',
        loadComponent: () =>
          import('./PatientPayments/patient-payment/patient-payment')
            .then(m => m.PatientPayment)
      },
      {
        path: 'bookAppointment',
        loadComponent: () =>
          import('./BookAppointment/book-appointment/book-appointment')
            .then(m => m.BookAppointment)
      }
    ]
  },

  /* ---------------- PATIENT PORTAL ---------------- */

  {
    path: 'patientPortal',
    canActivate: [portalAuthGuard],
    loadComponent: () =>
      import('./PatientPortal/patient-portal/patient-portal')
        .then(m => m.PatientPortal),
    children: [
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full'
      },
      {
        path: 'dashboard',
        runGuardsAndResolvers: 'always',
        loadComponent: () =>
          import('./PatientPortal/dashboard/dashboard')
            .then(m => m.Dashboard)
      },
      {
        path: 'myvisits',
        loadComponent: () =>
          import('./PatientPortal/my-visits/my-visits')
            .then(m => m.MyVisits)
      },
      {
        path: 'prescriptions',
        loadComponent: () =>
          import('./PatientPortal/prescriptions/prescriptions')
            .then(m => m.Prescriptions)
      },
      {
        path: 'forms',
        loadComponent: () =>
          import('./PatientPortal/my-forms/my-forms')
            .then(m => m.MyForms)
      },
      {
        path: 'activityLog',
        loadComponent: () =>
          import('./PatientPortal/activity-logs/activity-logs')
            .then(m => m.ActivityLogs)
      },
      {
        path: 'educationLibrary',
        loadComponent: () =>
          import('./PatientPortal/education-library/education-library')
            .then(m => m.EducationLibrary)
      },
      {
        path: 'profile',
        loadComponent: () =>
          import('./PatientPortal/profile/profile')
            .then(m => m.Profile)
      },
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full'
      }
    ]
  },

  /* ---------------- FALLBACK ---------------- */

  {
    path: 'noAccess',
    loadComponent: () =>
      import('./Status/no-access/no-access')
        .then(m => m.NoAccess)
  },
  {
    path: '',
    redirectTo: '/noAccess',
    pathMatch: 'full'
  }
];
